import companiesMdl from "./companies.mdl";

export default [...companiesMdl];
